(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["guarantees"] && !Shopify.designMode) return;
  try {
    // Handle variant update event
  document.addEventListener('variant:update', async (event) => {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('view', 'json');
    const variantData = await (await fetch(currentUrl.toString())).json();
    const guaranteeContainer = document.querySelector('.product-guarantee-container');
    if (!guaranteeContainer) return;
    if (variantData.guarantee?.icon && variantData.guarantee?.html) {
      guaranteeContainer.innerHTML = `
        <div class="product-guarantee">
          <div class="product-guarantee__content">
            <div class="product-guarantee__icon">
              <img src="${variantData.guarantee.icon}" alt="Guarantee icon" width="200" height="200">
            </div>
            <div class="product-guarantee__text text-body-base">
              ${variantData.guarantee.html}
            </div>
          </div>
        </div>
      `;
    } else {
      guaranteeContainer.innerHTML = '';
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hsa-fsa-eligible"] && !Shopify.designMode) return;
  try {
    // On Truemed-eligible variants, the callout link opens the Truemed popup by clicking the
  // widget's hidden "Learn more" button. Without the widget the link keeps its FAQ href.
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('.hsa-fsa-eligible a');
    if (!link) return;

    const trigger = document.querySelector('.truemed-widget-host .truemed-instructions-open');
    if (!trigger) return;

    event.preventDefault();
    trigger.click();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    const SCROLL_SELECTOR =
      '#quick-add-modal-content .variant-option__button-labels, #quick-add-modal-content .variant-option--buttons.toggle';
    const DRAG_THRESHOLD = 5;

    const scrollModeQuery = window.matchMedia(
      '(min-width: 750px) and ((max-width: 1280px) or (max-height: 799px))'
    );

    /** @param {Element} el */
    function isScrollable(el) {
      return el.scrollWidth > el.clientWidth + 1;
    }

    /** @param {ParentNode} root */
    function updateScrollableState(root) {
      if (!scrollModeQuery.matches) {
        root.querySelectorAll(SCROLL_SELECTOR).forEach((el) => el.classList.remove('is-scrollable'));
        return;
      }

      root.querySelectorAll(SCROLL_SELECTOR).forEach((el) => {
        el.classList.toggle('is-scrollable', isScrollable(el));
      });
    }

    const modalContent = document.getElementById('quick-add-modal-content');
    const dialog = document.getElementById('quick-add-dialog');

    if (!modalContent) return;

    const refreshScrollableState = () => updateScrollableState(modalContent);

    const observer = new MutationObserver(refreshScrollableState);
    observer.observe(modalContent, { childList: true, subtree: true });

    window.addEventListener('resize', refreshScrollableState);
    scrollModeQuery.addEventListener('change', refreshScrollableState);
    dialog?.addEventListener('dialog:open', refreshScrollableState);
    refreshScrollableState();

    document.addEventListener('pointerdown', (event) => {
      if (!scrollModeQuery.matches) return;
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (!(event.target instanceof Element)) return;

      const container = event.target.closest(SCROLL_SELECTOR);
      if (!container || !modalContent.contains(container) || !isScrollable(container)) return;

      const startX = event.clientX;
      const startScrollLeft = container.scrollLeft;
      let moved = false;

      /** @param {PointerEvent} moveEvent */
      const onPointerMove = (moveEvent) => {
        const deltaX = moveEvent.clientX - startX;

        if (!moved) {
          if (Math.abs(deltaX) < DRAG_THRESHOLD) return;
          moved = true;
          container.classList.add('is-dragging');
          container.setPointerCapture(moveEvent.pointerId);
        }

        moveEvent.preventDefault();
        container.scrollLeft = startScrollLeft - deltaX;
      };

      /** @param {PointerEvent} upEvent */
      const onPointerUp = (upEvent) => {
        document.removeEventListener('pointermove', onPointerMove);
        document.removeEventListener('pointerup', onPointerUp);
        container.classList.remove('is-dragging');

        if (container.hasPointerCapture(upEvent.pointerId)) {
          container.releasePointerCapture(upEvent.pointerId);
        }

        if (moved) {
          const preventClick = (clickEvent) => {
            clickEvent.preventDefault();
            clickEvent.stopImmediatePropagation();
          };

          container.addEventListener('click', preventClick, { capture: true, once: true });
        }

        refreshScrollableState();
      };

      document.addEventListener('pointermove', onPointerMove);
      document.addEventListener('pointerup', onPointerUp);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sorting"] && !Shopify.designMode) return;
  try {
    (function () {
    var DROP_UP = 'sorting-filter__options--drop-up';
    var PANEL_HEIGHT = 280;
    var BUFFER = 16;

    document.addEventListener('click', function (e) {
      var summary = e.target.closest('.sorting-filter .facets__panel > summary');
      if (!summary) return;

      var details = summary.parentElement;
      if (!details) return;

      var panel = details.querySelector('.sorting-filter__options');
      if (!panel) return;

      /*
       * At click time the browser has NOT yet toggled details.open.
       * So:
       *   details.open === false  →  the panel is ABOUT TO OPEN
       *   details.open === true   →  the panel is ABOUT TO CLOSE
       *
       * We pre-apply the class before the first render so there is
       * no visual flash / jump.
       */
      if (!details.open && window.innerWidth < 750) {
        /* Panel is about to open — decide direction now */
        var rect = summary.getBoundingClientRect();
        var spaceBelow = window.innerHeight - rect.bottom;

        if (spaceBelow < PANEL_HEIGHT + BUFFER) {
          panel.classList.add(DROP_UP);
        } else {
          panel.classList.remove(DROP_UP);
        }
      } else {
        /* Panel is about to close (or desktop) — clean up */
        panel.classList.remove(DROP_UP);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
